// >= desktop: split card + hero illustration
export const AUTH_DESKTOP_MIN = 1366;
export const AUTH_MOBILE_MAX = 640;

export const AUTH_MEDIA = {
  belowDesktop: `(max-width: ${AUTH_DESKTOP_MIN - 1}px)`,
  tablet: `(min-width: ${AUTH_MOBILE_MAX + 1}px) and (max-width: ${AUTH_DESKTOP_MIN - 1}px)`,
  mobile: `(max-width: ${AUTH_MOBILE_MAX}px)`,
};

